import { MenuItem } from '@/types/navigation';

// ベースとなるメニュー構造（ガイド項目を含まない）
const baseNavigationData: MenuItem[] = [
  {
    id: 'company',
    label: '会社情報',
    href: '/company/',
    styleTag: 'menu-cyan-blue', // 水色→青色
    children: [
      // --- 第2階層追加項目 ---
      {
        id: 'company-philosophy',
        label: '企業理念',
        href: '/company/philosophy/',
        children: [
          // --- 第3階層追加項目 ---
          { id: 'company-philosophy-vision', label: 'ビジョン', href: '/company/philosophy/vision/' },
          { id: 'company-philosophy-mission', label: 'ミッション', href: '/company/philosophy/mission/' },
          { id: 'company-philosophy-values', label: '価値観', href: '/company/philosophy/values/' }
        ]
      },
      {
        id: 'company-history',
        label: '会社沿革',
        href: '/company/history/',
        children: [
          { id: 'company-history-foundation', label: '設立経緯', href: '/company/history/foundation/' },
          { id: 'company-history-timeline', label: '年表', href: '/company/history/timeline/' },
          { id: 'company-history-milestones', label: 'マイルストーン', href: '/company/history/milestones/' }
        ]
      },
      {
        id: 'company-team',
        label: 'チーム紹介',
        href: '/company/team/',
        children: [
          { id: 'company-team-leadership', label: '経営陣', href: '/company/team/leadership/' },
          { id: 'company-team-advisors', label: 'アドバイザー', href: '/company/team/advisors/' },
          { id: 'company-team-employees', label: '社員紹介', href: '/company/team/employees/' }
        ]
      },
      {
        id: 'company-access',
        label: 'アクセス',
        href: '/company/access/',
        children: [
          { id: 'company-access-location', label: '所在地詳細', href: '/company/access/location/' },
          { id: 'company-access-directions', label: '交通案内', href: '/company/access/directions/' },
          { id: 'company-access-facilities', label: '施設・設備', href: '/company/access/facilities/' },
          { id: 'company-access-parking', label: '駐車場案内', href: '/company/access/parking/' }
        ]
      }
    ]
  },
  {
    id: 'services',
    label: 'サービス',
    href: '/services/',
    styleTag: 'menu-cyan-blue', // 水色→青色
    children: [
      {
        id: 'services-system-development',
        label: 'システム開発',
        href: '/services/system-development/',
        children: [
          { id: 'services-system-development-integrated-development', label: '開発環境整備・プラットフォーム構築', href: '/services/system-development/integrated-development/' },
          { id: 'services-system-development-website-creation', label: 'Webサイト制作', href: '/services/system-development/website-creation/' },
          { id: 'services-system-development-web-app-development', label: 'Webアプリケーション開発', href: '/services/system-development/web-app-development/' },
          { id: 'services-system-development-ai-integration', label: 'AI統合開発', href: '/services/system-development/ai-integration/' }
        ]
      },
      {
        id: 'services-content-production',
        label: 'コンテンツ制作',
        href: '/services/content-production/',
        children: [
          { id: 'services-content-production-ai-copywriting', label: 'AIコピーライティング・テクニカルライティング', href: '/services/content-production/ai-copywriting/' },
          { id: 'services-content-production-music-services', label: '音楽制作サービス', href: '/services/content-production/music-services/' },
          { id: 'services-content-production-brand-design', label: 'ブランドデザイン・ビジュアルコンテンツ制作', href: '/services/content-production/brand-design/' },
          { id: 'services-content-production-video-production', label: '動画コンテンツ制作', href: '/services/content-production/video-production/' }
        ]
      },
      {
        id: 'services-consulting',
        label: 'AIコンサルティング',
        href: '/services/consulting/',
        children: [
          { id: 'services-consulting-ai-strategy', label: 'AI戦略・ロードマップ策定', href: '/services/consulting/ai-strategy/' },
          { id: 'services-consulting-model-selection', label: 'モデル・ツール選定', href: '/services/consulting/model-selection/' },
          { id: 'services-consulting-governance', label: 'AIガバナンス・リスク管理', href: '/services/consulting/governance/' },
          { id: 'services-consulting-workflow-integration', label: 'AIワークフロー統合', href: '/services/consulting/workflow-integration/' },
          { id: 'services-consulting-training-enablement', label: 'AIリテラシー研修・人材育成', href: '/services/consulting/training-enablement/' }
        ]
      }
    ]
  },
  {
    id: 'cases',
    label: '事例紹介',
    href: '/cases/',
    styleTag: 'menu-cyan-blue', // 水色→青色
    children: [
      {
        id: 'cases-own-projects',
        label: '自社事例',
        href: '/cases/own-projects/',
        children: [
          { id: 'cases-own-projects-youtube-channel', label: 'YouTube動画制作', href: '/cases/own-projects/youtube-channel/' },
          { id: 'cases-own-projects-website-creation', label: '自社ウェブサイト制作', href: '/cases/own-projects/website-creation/' }
        ]
      },
      {
        id: 'cases-collaborations',
        label: 'コラボレーション',
        href: '/cases/collaborations/',
        children: [
          { id: 'cases-collaborations-tada-satoru', label: '多田覚', href: '/cases/collaborations/tada-satoru/' }
        ]
      },
      {
        id: 'cases-client-projects',
        label: '協業事例',
        href: '/cases/client-projects/',
        children: [
          { id: 'cases-client-projects-unext-holdings', label: 'U-NEXT HOLDINGS様', href: '/cases/client-projects/unext-holdings/' }
        ]
      }
    ]
  },
  {
    id: 'news',
    label: 'ニュース',
    href: '/news/',
    styleTag: 'menu-cyan-blue', // 水色→青色
    children: [
      { 
        id: 'news-press-releases', 
        label: 'プレスリリース', 
        href: '/news/press-releases/',
        children: [
          { id: 'news-press-releases-2025', label: '2025年', href: '/news/press-releases/2025/' },
          { id: 'news-press-releases-company', label: '会社関連', href: '/news/press-releases/company-launch/' },
          { id: 'news-press-releases-website', label: 'ウェブサイト関連', href: '/news/press-releases/website-renewal/' }
        ]
      },
      { 
        id: 'news-announcements', 
        label: 'お知らせ', 
        href: '/news/announcements/',
        children: [
          { id: 'news-announcements-company', label: '会社関連', href: '/news/announcements/company/' },
          { id: 'news-announcements-service', label: 'サービス関連', href: '/news/announcements/service/' },
          { id: 'news-announcements-office-hours', label: '営業時間', href: '/news/announcements/office-hours-change/' },
          { id: 'news-announcements-maintenance', label: 'メンテナンス', href: '/news/announcements/website-maintenance/' }
        ]
      },
      { 
        id: 'news-events', 
        label: 'イベント・セミナー', 
        href: '/news/events/',
        children: [
          { id: 'news-events-upcoming', label: '開催予定', href: '/news/events/upcoming/' },
          { id: 'news-events-reports', label: '開催レポート', href: '/news/events/reports/' }
        ]
      },
      { 
        id: 'news-service-updates', 
        label: 'サービス更新情報', 
        href: '/news/service-updates/',
        children: [
          { id: 'news-service-updates-features', label: '機能追加', href: '/news/service-updates/features/' },
          { id: 'news-service-updates-improvements', label: '改善・最適化', href: '/news/service-updates/improvements/' }
        ]
      }
    ]
  },
  {
    id: 'sustainability',
    label: 'サステナビリティ',
    href: '/sustainability/',
    styleTag: 'menu-cyan-blue', // 水色→青色
    children: [
      {
        id: 'sustainability-environment',
        label: '環境への取り組み',
        href: '/sustainability/environment/',
        children: [
          { id: 'sustainability-environment-carbon-neutral', label: 'カーボンニュートラル', href: '/sustainability/environment/carbon-neutral/' },
          { id: 'sustainability-environment-green-it', label: 'グリーンIT', href: '/sustainability/environment/green-it/' },
          { id: 'sustainability-environment-recycling', label: 'リサイクル', href: '/sustainability/environment/recycling/' }
        ]
      },
      {
        id: 'sustainability-social',
        label: '社会への貢献',
        href: '/sustainability/social/',
        children: [
          { id: 'sustainability-social-diversity', label: 'ダイバーシティ', href: '/sustainability/social/diversity/' },
          { id: 'sustainability-social-education', label: '教育支援', href: '/sustainability/social/education/' },
          { id: 'sustainability-social-community', label: '地域貢献', href: '/sustainability/social/community/' }
        ]
      },
      {
        id: 'sustainability-governance',
        label: 'ガバナンス',
        href: '/sustainability/governance/',
        children: [
          { id: 'sustainability-governance-compliance', label: 'コンプライアンス', href: '/sustainability/governance/compliance/' },
          { id: 'sustainability-governance-risk-management', label: 'リスク管理', href: '/sustainability/governance/risk-management/' },
          { id: 'sustainability-governance-transparency', label: '透明性', href: '/sustainability/governance/transparency/' }
        ]
      }
    ]
  },
  {
    id: 'careers',
    label: '採用情報',
    href: '/careers/',
    styleTag: 'menu-cyan-blue', // 水色→青色
    children: [
      {
        id: 'careers-new-graduates',
        label: '新卒採用',
        href: '/careers/new-graduates/',
        children: [
          { id: 'careers-new-graduates-engineer', label: 'エンジニア職', href: '/careers/new-graduates/engineer/' },
          { id: 'careers-new-graduates-business', label: 'ビジネス職', href: '/careers/new-graduates/business/' },
          { id: 'careers-new-graduates-designer', label: 'デザイナー職', href: '/careers/new-graduates/designer/' }
        ]
      },
      {
        id: 'careers-mid-career',
        label: '中途採用',
        href: '/careers/mid-career/',
        children: [
          { id: 'careers-mid-career-tech-lead', label: 'テックリード', href: '/careers/mid-career/tech-lead/' },
          { id: 'careers-mid-career-project-manager', label: 'プロジェクトマネージャー', href: '/careers/mid-career/project-manager/' },
          { id: 'careers-mid-career-sales', label: 'セールス', href: '/careers/mid-career/sales/' }
        ]
      },
      {
        id: 'careers-internships',
        label: 'インターンシップ',
        href: '/careers/internships/',
        children: [
          { id: 'careers-internships-summer', label: 'サマーインターン', href: '/careers/internships/summer/' },
          { id: 'careers-internships-winter', label: 'ウィンターインターン', href: '/careers/internships/winter/' },
          { id: 'careers-internships-long-term', label: '長期インターン', href: '/careers/internships/long-term/' }
        ]
      }
    ]
  },
  {
    id: 'contact',
    label: 'お問い合わせ',
    href: '/contact/',
    styleTag: 'menu-cyan-blue', // 水色→青色
    children: [
      { 
        id: 'contact-support', 
        label: 'サポート', 
        href: '/contact/support/',
        children: [
          { id: 'contact-support-technical', label: '技術サポート', href: '/contact/support/technical/' },
          { id: 'contact-support-account', label: 'アカウント管理', href: '/contact/support/account/' },
          { id: 'contact-support-billing', label: '請求・支払い', href: '/contact/support/billing/' }
        ]
      },
      { 
        id: 'contact-sales', 
        label: '見積り・導入相談', 
        href: '/contact/sales/',
        children: [
          { id: 'contact-sales-quote', label: '見積もり依頼', href: '/contact/sales/quote/' },
          { id: 'contact-sales-demo', label: 'デモ依頼', href: '/contact/sales/demo/' },
          { id: 'contact-sales-upgrade', label: 'アップグレード', href: '/contact/sales/upgrade/' }
        ]
      },
      { 
        id: 'contact-press', 
        label: 'メディア・取材', 
        href: '/contact/press/',
        children: [
          { id: 'contact-press-release', label: 'プレスリリース', href: '/contact/press/release/' },
          { id: 'contact-press-interview', label: 'インタビュー', href: '/contact/press/interview/' },
          { id: 'contact-press-materials', label: '素材提供', href: '/contact/press/materials/' }
        ]
      },
      { 
        id: 'contact-partnership', 
        label: 'パートナーシップ', 
        href: '/contact/partnership/',
        children: [
          { id: 'contact-partnership-alliance', label: '業務提携', href: '/contact/partnership/alliance/' },
          { id: 'contact-partnership-reseller', label: '販売代理', href: '/contact/partnership/reseller/' },
          { id: 'contact-partnership-technology', label: '技術連携', href: '/contact/partnership/technology/' }
        ]
      },
      { 
        id: 'contact-feedback', 
        label: 'フィードバック', 
        href: '/contact/feedback/',
        children: [
          { id: 'contact-feedback-feature', label: '機能要望', href: '/contact/feedback/feature/' },
          { id: 'contact-feedback-bug', label: 'バグ報告', href: '/contact/feedback/bug/' },
          { id: 'contact-feedback-general', label: '一般的なご意見', href: '/contact/feedback/general/' }
        ]
      }
    ]
  }
];

// 自動で「メニュートップ」「◯◯のメニュー」「◯◯」などのガイド項目を挿入する
const insertGuideNodes = (root: MenuItem): MenuItem => {
  if (!root.children || root.children.length === 0) {
    return root;
  }

  // --- 第2階層ガイド（root 直下） ---
  const secondIds = {
    guide: `${root.id}-menu-guide`,
    top: `${root.id}-menu-top`,
    label: `${root.id}-menu-label`
  } as const;

  const alreadySecond = root.children.some(c => c.id === secondIds.guide);
  if (!alreadySecond) {
    const secondGuides: MenuItem[] = [
      // 第2階層: メニューガイド
      { id: secondIds.top, label: 'メインメニュー', href: '/', styleTag: 'menu-gradient-sky-light' } // 水色と空色のグラデーション
    ];
    root.children = [...secondGuides, ...root.children];
  }

  // --- 第3階層ガイド（root.children 配下に children を持つ項目に追加） ---
  root.children = root.children.map(child => {

    if (!child.children || child.children.length === 0) {
      return child;
    }

    const thirdGuideIds = {
      top: `${child.id}-menu-top`,
      left: `${child.id}-nav-left`,
      guide: `${child.id}-menu-guide`,
      label: `${child.id}-menu-label`
    } as const;

    const alreadyHas = child.children.some(c => c.id === thirdGuideIds.guide);
    if (!alreadyHas) {
      const thirdGuides: MenuItem[] = [
        // 第3階層ガイド
        { id: thirdGuideIds.top, label: 'メインメニュー', href: '/', styleTag: 'menu-gradient-sky-light' }, // 水色と空色のグラデーション
        { id: thirdGuideIds.left, label: `${root.label}のメニュー`, href: root.href, styleTag: 'menu-gradient-light-blue' } // 水色→青色グラデーション
      ];
      child.children = [...thirdGuides, ...child.children];
    }


    // 再帰（第4階層以降はスキップ）
    return child;
  });

  return root;
};

export const navigationData: MenuItem[] = baseNavigationData.map(item => insertGuideNodes({ ...item }));